export const DESIRED_SIZE_OPTIONS = ["Studio", "2 1/2", "3 1/2", "4 1/2", "5 1/2", "Plus de 5 1/2"]
